import { allSignals, isSequential, pinLabel, sourceKey } from '../engine/registry';
import { clone } from './projects';

// Rename the actual terminal/output label so circuit and timing views agree.
export function renameSignal(project, signalId, value) {
  const name = value.trim();
  if (!name || name.length > 24) throw new Error('Use a signal name of 1–24 characters.');
  const before = allSignals(project), signal = before.find(s => s.id === signalId);
  if (!signal) throw new Error('This signal is no longer in the circuit.');
  const next = clone(project);
  if (signal.terminal) {
    const c = next.components.find(c => c.id === signal.component);
    const old = pinLabel(c, signal.pin);
    c.config.pinLabels = { ...c.config.pinLabels, [signal.pin]: name };
    const input = next.inputs.find(i => i.id === signal.source?.input);
    if (input?.name === old) input.name = name;
  } else if (signal.source?.input) {
    const input = next.inputs.find(i => i.id === signal.source.input), old = input.name;
    input.name = name;
    for (const wire of next.connections.filter(e => e.from.input === input.id)) {
      const c = next.components.find(c => c.id === wire.to.component);
      if (pinLabel(c, wire.to.pin) === old) c.config.pinLabels = { ...c.config.pinLabels, [wire.to.pin]: name };
    }
  } else {
    const c = next.components.find(c => c.id === signal.component);
    if (c.type === 'CLOCK') { c.name = name; delete c.config.pinLabels.CLK; }
    else {
      c.config.pinLabels = { ...c.config.pinLabels, [signal.pin]: name };
      if (isSequential(c) && signal.pin === 'Q') c.config.output = name;
    }
  }
  const after = allSignals(next);
  const changed = new Set(after.filter(s => s.name !== before.find(old => old.id === s.id)?.name).map(s => s.id));
  changed.add(signalId);
  for (const s of after.filter(s => changed.has(s.id))) {
    if (after.some(other => other.id !== s.id && other.name === s.name && sourceKey(other.source) !== sourceKey(s.source))) {
      throw new Error(`“${s.name}” is already used by another signal.`);
    }
  }
  next.timing.aliases = { ...next.timing.aliases };
  changed.forEach(id => delete next.timing.aliases[id]);
  return next;
}
